import { render, staticRenderFns } from "./CategoryFormView.vue?vue&type=template&id=cba46d4c&"
import script from "./CategoryFormView.vue?vue&type=script&lang=js&"
export * from "./CategoryFormView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports